var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('carousel',[_c('slide',[_vm._v("\n      Slide 1 Content\n    ")]),_vm._v(" "),_c('slide',[_vm._v("\n      Slide 2 Content\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }